import { TextField, Box, Button, Typography } from '@material-ui/core';
import RonadIcons from '../iconComponent';
import Modal from '../Modal';
import React, { useEffect, useRef } from 'react';
import { verifyEmail } from '../../api/auth/post';
import { useState } from 'react';
import decodeToken from '../../utils/decodeJwt';
import styles from './infologin.module.scss';
const InfoLoginModal = () => {
  const [shouldShowInfoModal, setShouldShowInfoModal] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [email, setEmail] = useState('');
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [decodedToken, setDecodedToken] = useState({});
  const [openResendDiolog, setOpenResentDiolg] = useState(false)
  const submitEmail = async () => {
    try {
      setIsSubmiting(true);
      await verifyEmail(email);
      setIsSubmiting(false);

      setShouldShowInfoModal(false);
      setOpenResentDiolg(false)
      setOpenInfoModal(true);
    } catch (error) {
      if (error?.response?.status === 400) {
        setShouldShowInfoModal(false);
        setOpenResentDiolg(false)
        setShowErrorModal(true);
      }
      setIsSubmiting(false);
    }
  };
  useEffect(() => {
    if (
      localStorage.getItem('token') &&
      localStorage.getItem('logintype') === 'partner'
    ) {
      const decodedCurrentToken = decodeToken(localStorage.getItem('token'));
      setDecodedToken({
        ...decodedCurrentToken,
        type: localStorage.getItem('logintype') === 'partner',
      });
      setEmail(decodedCurrentToken.sub.slice(3));
    }
  }, []);
  return (
    <>
      <Modal
        maxWidth="md"
        onClose={() => setShouldShowInfoModal(false)}
        open={shouldShowInfoModal}
        title="ایمیل خود را وارد کنید"
        content={
          <Box>
            <Box className={styles.emailModalContainer}>
              لینک ثبت نام در سامانه احراز هویت مرکزی روناد به ایمیل زیر ارسال
              خواهد شد. در صورتی که به این ایمیل دسترسی ندارید، آدرس ایمیل دیگری
              وارد کنید.
              <Box style={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
                <TextField
                  className="mt-2"
                  variant="outlined"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="لطفا ایمیل خود را وارد کنید"
                />
              </Box>
            </Box>
            <Box className={styles.emailBottonContainer}>
              <Button
                className="mt-4"
                type="button"
                size="large"
                autoFocus
                variant="contained"
                color="primary"
                loading={isSubmiting}
                disabled={isSubmiting}
                onClick={submitEmail}
              >
                {'تایید ایمیل'}
                <RonadIcons name={'chevronLeft'} />
              </Button>
            </Box>
          </Box>
        }
      />
      <Modal
        hideHeader
        maxWidth="md"
        onClose={() => setOpenInfoModal(false)}
        open={openInfoModal}
        content={
          <Box className={styles.confirmEmailContainer}>
            <Box className={styles.emailContentContainer}>
              <RonadIcons name="checkCircle" className="text-green" />
              <Box>
                <Typography className={styles.confirmModalTitle}>
                  ایمیل ثبت نام در سامانه احراز هویت مرکزی روناد با موفقیت برای
                  شما ارسال شد.
                </Typography>
                <Typography className={`${styles.emailInfoText} mt-2`}>
                  برای تکمیل ثبت نام در این سامانه، به ایمیل خود مراجعه کنید و
                  مراحل مشخص شده را انجام دهید.
                </Typography>
              </Box>
            </Box>
            <Box className={styles.confirmEmailButton}>
              <Button
                onClick={() => setOpenInfoModal(false)}
                variant="contained"
                color="primary"
              >
                متوجه شدم
                <RonadIcons name="check" />
              </Button>
            </Box>
          </Box>
        }
      />
      <Modal
        hideHeader
        maxWidth="md"
        onClose={() => setOpenResentDiolg(false)}
        open={openResendDiolog}
        content={
          <Box className={styles.confirmEmailContainer}>
            <Box className={styles.emailContentContainer}>
              <RonadIcons name="checkCircle" className="text-green" />
              <Box>
                <Typography className={styles.confirmModalTitle}>
                  لینک احراز هویت به  ایمیل {email} مجددا ارسال شود؟
                </Typography>
              </Box>
            </Box>
            <Box className={styles.confirmEmailButton}>
              <Button
                onClick={() => setOpenResentDiolg(false)}
                variant="contained"
                color="default"
                className='ml-1'
              >
                انصراف
              </Button>
              <Button
                onClick={() => submitEmail(false)}
                variant="contained"
                color="primary"
                className='ml-1'
                loading={isSubmiting}
                disabled={isSubmiting}
              >
                تأیید
              </Button>


            </Box>
          </Box>
        }
      />
      <Modal
        hideHeader
        maxWidth="md"
        onClose={() => setShowErrorModal(false)}
        open={showErrorModal}
        content={
          <Box className={styles.confirmEmailContainer}>
            <Box className={styles.emailContentContainer}>
              <RonadIcons
                name="times"
                className={`text-danger ${styles.closeIcon}`}
              />
              <Box>
                <Typography className={styles.confirmModalTitle}>
                  ایمیل ثبت نام در سامانه احراز هویت مرکزی روناد قبلا برای شما
                  ارسال شده است.
                </Typography>
                <Typography className={`${styles.emailInfoText} mt-2`}>
                  برای تکمیل ثبت نام در این سامانه، به ایمیل خود مراجعه کنید و
                  مراحل مشخص شده را انجام دهید.
                </Typography>
              </Box>
            </Box>
            <Box className={styles.confirmEmailButton}>
              <Button
                onClick={() => setShowErrorModal(false)}
                variant="contained"
                color="primary"
                size="small"
              >
                <Typography className="ml-2">متوجه شدم</Typography>
                <RonadIcons className={styles.confirmIcon} name="check" />
              </Button>
            </Box>
          </Box>
        }
      />
      {localStorage.getItem('logintype') === 'partner' &&
        (!decodedToken?.ssoStatus ? (
          <Box className={styles.alertInfoContainer}>
            <Box>
              <Box className={styles.alertTextWrapper}>
                <RonadIcons
                  className={styles.infoCirle}
                  size={1}
                  name="information"
                />
                <Typography className={styles.alertText}>
                  کاربرگرامی، برای دسترسی به خدمات جدید روناد، می بایست  حداکثر تا ۳۱ اردیبهشت ماه در سامانه احراز هویت مرکزی ثبت نام نمایید. بعد از این تاریخ، دسترسی به پنل به روش فعلی امکان پذیر نخواهد بود.                </Typography>
              </Box>
            </Box>
            <Button
              onClick={() => setShouldShowInfoModal(true)}
              variant="outlined"
              className={`${styles.alertButton} mt-2`}
            >
              ثبت نام احراز هویت مرکزی
              <RonadIcons name={'chevronLeft'} />
            </Button>
          </Box>
        ) : (
          decodedToken?.ssoStatus === 'IN_PROGRESS' && (
            <>
              <Box className={styles.inprogressAlertContainer}>
                <Box>
                  <Box className={styles.inprogressTextWrapper}>
                    <RonadIcons
                      name="checkCircle"
                      className={`text-green mt-1 ml-2 ${styles.checkIcon}`}
                    />
                    <Typography>
                      {`   ایمیل ثبت نام در سامانه احراز هویت مرکزی روناد به آدرس 
                      ${email}
                      ارسال شد.`}
                    </Typography>
                  </Box>
                  <Box>
                    برای تکمیل ثبت نام در این سامانه، به ایمیل خود مراجعه کنید و
                    مراحل مشخص شده را انجام دهید.
                  </Box>
                </Box>
                <Button
                  onClick={() => setOpenResentDiolg(true)}
                  variant="outlined"
                  className={`${styles.alertButton} mt-2`}
                >
                  ارسال مجدد لینک احراز هویت
                  <RonadIcons name={'chevronLeft'} />
                </Button>
              </Box>
            </>
          )
        ))}
    </>
  );
};
export default InfoLoginModal;
